import { TweetEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const ComposableTweet = ({ tweetId, ...props }) => {
  const ref = useRef();

  // maxWidth is used to determine the maximum width for
  // the Tweet inside its parent (which is this component).
  const [maxWidth, setMaxWidth] = useState();

  // On window resize we have to update the max-width for the Tweet.
  const handleResize = () =>
    setMaxWidth(
      Math.max(250, Math.min(550, ref.current.getBoundingClientRect().width))
    );

  useEffect(() => {
    if (!process.browser) {
      return null;
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [ref]);

  return (
    <GridItem
      ref={ref}
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <TweetEmbed id={tweetId} {...props} options={{ width: maxWidth }} />
    </GridItem>
  );
};

ComposableTweet.propTypes = {
  tweetId: PropTypes.string.isRequired,
};

export default ComposableTweet;
